import React from 'react'
import { ReactSpecimen } from 'catalog';

const stageKhMarkup = props => {

  return (
    <ReactSpecimen responsive={['desktop', 'tablet portrait', 'mobile portrait']} plain={true}>
      <div className="component container col-12 stage">
        <div className="component-content">
          <div className="row">
            <div className="component plain-html col-12">
              <div className="component-content">
                <div
                  className="component stage-main mod-stage mod-stage--parallax mod-stage--parallax-kh col-12">
                  <div className="component-content">
                    <div className="field-video">
                      <img
                        src="https://www.zurich.com/-/media/project/zurich/dotcom/careers/images/stage-diw.jpg?h=1250&la=en&w=2500"
                        alt="people not gender" width="2500" height="1250" />
                      <video playsinline="playsinline" muted="muted" preload="auto" autoPlay=""
                             loop="">
                        <source src="https://www.zurich.com/-/media/project/zurich/dotcom/careers/images/stage-diw-vid.mp4?la=en" />
                      </video>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ReactSpecimen>
  )
}

stageKhMarkup.propTypes = {}

export default stageKhMarkup;



// WEBPACK FOOTER //
// ./catalog/stage/stage-kh-markup.js